import styled from '@emotion/styled'
import { Box, alpha } from '@mui/material'
import { ReactElement } from 'react'

const FullPageDiv = styled('div')({
    position: 'fixed',
    bottom: 0,
    top: 0,
    right: 0,
    left: 0,
    overflow: 'auto',
    backgroundImage:
        'radial-gradient(circle, rgba(90, 223, 180, 1) 0%, rgba(18, 174, 133, 1) 50%, rgba(16, 172, 132, 1) 100%)',
})

const FullPageLayout = ({ children }: { children: ReactElement }) => {
    return (
        <FullPageDiv>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                }}
            >
                <Box
                    sx={{
                        maxWidth: 900,
                        backgroundColor: (theme) => alpha(theme.palette.common.white, 0.2),
                        borderRadius: 4,
                        padding: '16px 42px 16px 42px',
                    }}
                    style={{ textAlign: 'center' }}
                >
                    {children}
                </Box>
            </Box>
        </FullPageDiv>
    )
}

export default FullPageLayout
